import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/email.svg'


const _hoisted_1 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-5 place-items-center items-center lg:place-items-stretch place-content-center md:h-screen mt-5 md:mt-0" }
const _hoisted_2 = {
  key: 0,
  class: "w-full sm:w-auto lg:w-full"
}
const _hoisted_3 = { class: "bg-white shadow-md rounded-xl overflow-hidden lg:m-10" }
const _hoisted_4 = { class: "bg-gray-50 p-5" }
const _hoisted_5 = { class: "px-5 py-5" }
const _hoisted_6 = { class: "flex flex-col my-4" }
const _hoisted_7 = { class: "flex justify-start flex-wrap gap-1" }
const _hoisted_8 = {
  for: "binary",
  class: "font-[600]"
}
const _hoisted_9 = { class: "bg-gray-50 p-4 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg" }
const _hoisted_10 = {
  key: 1,
  class: "hidden lg:flex justify-end lg:m-14"
}
const _hoisted_11 = {
  key: 2,
  id: "email-send-section",
  class: "col-span-12"
}
const _hoisted_12 = { class: "flex justify-center items-center" }
const _hoisted_13 = { class: "bg-white shadow-sm rounded-md border border-gray-300 md:w-3/6" }
const _hoisted_14 = { class: "bg-gray-50 border-b border-gray-300 p-4" }
const _hoisted_15 = { class: "flex flex-col justify-center items-center gap-3 my-10" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "h-72 w-100",
  alt: "login-img"
}, null, -1)
const _hoisted_17 = { class: "px-8 md:px-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "bg-gray-50 flex justify-end items-center mt-3 border-t border-t-gray-300 rounded-b-lg p-8" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ComputerComponent = _resolveComponent("ComputerComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.hasSend)
      ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Registre-se como aluno",
                en: "Register as a student",
              })), 1)
            ]),
            _createElementVNode("form", {
              onSubmit: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.sendEmailToUser()), ["prevent"]))
            }, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_InputText, {
                    id: "email-input",
                    type: "text",
                    modelValue: _ctx.form.email,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.email) = $event)),
                    placeholder: "E-mail",
                    class: _normalizeClass(_ctx.v$.form.email.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.email.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: "Já tem uma conta? Faça o",
                    en: "Already have an account?",
                  })), 1),
                  _createElementVNode("a", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.go.redirectTo('sign-in'))),
                    class: "text-h-primary-500 hover:text-h-primary-700 cursor-pointer font-[700]"
                  }, " Login ")
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_Button, {
                  type: "submit",
                  label: "Enviar",
                  class: "btn-primary"
                })
              ])
            ], 32)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.hasSend)
      ? (_openBlock(), _createElementBlock("section", _hoisted_10, [
          _createVNode(_component_ComputerComponent, { icon: "md-assignmentind-twotone" })
        ]))
      : (_openBlock(), _createElementBlock("section", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Registre-se como aluno",
                  en: "Register as a student",
                })), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Uma solicitação para completar o seu cadastro foi enviada para o seu e-mail. Por favor, verifique a sua caixa de entrada.",
                  en: "A request to complete your registration has been sent to your email. Please check your inbox.",
                })), 1)
              ]),
              _hoisted_18
            ])
          ])
        ]))
  ]))
}